module.exports = __webpack_public_path__ + "media/images/fbcalls/8-4d44ed22579528cf39895bcb72a9b7b9.png";